exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".c-width{margin-right:0!important;padding:0!important;width:80px!important}.card{margin-bottom:2px}.card-body{padding:10px}.h-40{height:40%!important}.h-60{height:60%!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c0c3a2e0","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/views/tenant/pos/partials/payment.vue
// module id = rNNh
// module chunks = 0